  import axios from 'axios'
  //const jsonp = require('jsonp');
  import jsonp from 'jsonp'
  import Vue from 'vue'
  export const Get = (url) => {
    return axios.get(url)
        .then(response => response.data)
        .catch(err => {
          console.log('get err', err)
        })
  }
  export const GetTwitter = (url) => {
    return axios.get(url)
         .then(response => response.data)
         .catch(err => err.response.data)
   }
 
  export const GetFbGraph = (url) => {
    return axios.get(url)
        .then(response => response.data)
        .catch(err => err.response.data.error)
  }
  export const Post = (url, payload) => {
    return axios.post(url, payload)
        .then(response => response.data)
        .then(data => data).catch(err => {
          console.log('post err', err)
        })
  }

  export const JsonP = (url) => {
    let headers = {
      'access-control-allow-credentials': 'true',
      'access-control-allow-origin': 'https://devf7_apps.app-controller.net'
    }
    return new Promise((resolve, reject) => {
      jsonp(url, headers, (err, data) => {
        if (err) {
          reject(err)
        } else {
          resolve(data)
        }

      })
    })
  }

  export const  Jsonp =  (url, callbackfun) => {
      jsonp(url, {callbackQuery: 'cb', callbackName: 'callbackfun'}, (err, data) => {
      if (err) {
        console.error(err.message);
      } else {
        callbackfun(data)
      }
    });
  }
  


// WEBPACK FOOTER //
// ./src/modules/wrapper/apiWrapper.js